import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import LidarOverviewContextProvider from "./context/LidarOverviewContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {LIDARS} from "../../util/RouteConstants";
import LidarTesterContextProvider from "./context/LidarTesterContext";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class LidarPage extends Component {
    render() {
        return (
            <Column>
                <LidarOverviewContextProvider>
                    <LidarTesterContextProvider>
                    <TabLayout routes={LIDARS} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={LIDARS}/>
                    </LidarTesterContextProvider>
                </LidarOverviewContextProvider>
            </Column>
        )
    }
}

export default LidarPage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/LidarPage.js